import { cn } from "../lib/utils.ts";

export type Activity = "mirror" | "memory";

export interface ActivityOption {
  id: Activity;
  label: string;
  icon: string;
  description: string;
}

export const ACTIVITIES: ActivityOption[] = [
  {
    id: "mirror",
    label: "Mirror Me",
    icon: "🪞",
    description: "Translate what you say.",
  },
  {
    id: "memory",
    label: "Memory",
    icon: "🧠",
    description: "Chat with an AI that remembers.",
  },
];

interface Props {
  value: Activity;
  onChange: (a: Activity) => void;
}

export function ActivitySelector({ value, onChange }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label="Activity"
      className="inline-flex bg-white/10 rounded-full p-1 gap-1"
    >
      {ACTIVITIES.map((a) => {
        const active = a.id === value;
        return (
          <button
            key={a.id}
            role="radio"
            aria-checked={active}
            title={a.description}
            onClick={() => onChange(a.id)}
            className={cn(
              "flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-semibold transition-colors",
              active
                ? "bg-white text-canvas shadow"
                : "text-white/80 hover:text-white hover:bg-white/10",
            )}
          >
            <span className="text-base leading-none">{a.icon}</span>
            <span>{a.label}</span>
          </button>
        );
      })}
    </div>
  );
}
